import { InitConfiguration } from 'model/init-config';

export const config: InitConfiguration = {
	override: {},
};
